import { render, staticRenderFns } from "./sheader.vue?vue&type=template&id=5f5d395e&scoped=true&"
import script from "./sheader.vue?vue&type=script&lang=js&"
export * from "./sheader.vue?vue&type=script&lang=js&"
import style0 from "./sheader.vue?vue&type=style&index=0&id=5f5d395e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5d395e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ALink: require('/app/components/aLink.vue').default,SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
